import React from "react";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { useRecoilValue } from "recoil";
import { accountAtom } from "modules/Login/atoms/AccountAtom";

interface IContainerStyle {
  width?: string;
  height?: string;
}
interface IGoogleMap {
  center: google.maps.LatLng | google.maps.LatLngLiteral;
  physicalAddress: string;
  zoom?: number;
  containerStyle?: IContainerStyle;
}

type Library = (
  | "places"
  | "drawing"
  | "geometry"
  | "localContext"
  | "visualization"
)[];
const libraries: Library = ["places"];
const GoogleMaps: React.FC<IGoogleMap> = ({
  center,
  physicalAddress,
  containerStyle = {
    width: "230px",
    height: "200px",
  },
  zoom = 14,
}) => {
  const user = useRecoilValue(accountAtom);
  const urlLink = "https://maps.google.com/?q=" + physicalAddress;
  const gMapOptions = {
    controlSize: 20,
    mapTypeControl: false,
    streetViewControl: false,
  };
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: user?.googleApiKey ? user?.googleApiKey : "",
    libraries: libraries,
  });
  return (
    <>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoom}
          options={gMapOptions}
          onClick={() => window.open(urlLink)}
        >
          {/* Child components, such as MarkerFs, info windows, etc. */}
          <MarkerF
            position={center}
            title={physicalAddress}
            onClick={() => window.open(urlLink)}
          >
            {/* <InfoWindow position={center}>
            <div className="googlemap-info">{physicalAddress}</div>
          </InfoWindow> */}
          </MarkerF>
          <></>
        </GoogleMap>
      )}
    </>
  );
};

export default GoogleMaps;
